import UAParser from 'ua-parser-js';

export class UAInfo {
    constructor(){
        let raw_ua = window.navigator.userAgent.toLowerCase();    
        this._UA = (new UAParser()).getResult();;
        this._IPAD_SPECIAL = raw_ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
    }

    get UA(){
        return this._UA;
    }

    setTabletViewport(width='1040') {
        if (this._UA.device.type === 'tablet' || this._IPAD_SPECIAL) {
            document.querySelector("meta[name='viewport']").setAttribute('content', 'width=' + width);
        }
    };
    
    setDeviceClass() {
        if(this._UA.device.type == 'tablet' || this._IPAD_SPECIAL){
            document.body.classList.add('ua_tablet');
        } else if(this._UA.device.type === 'mobile'){
            document.body.classList.add('ua_sp');
        } else if(this._UA.device.type == undefined){
            document.body.classList.add('ua_pc');
        }
    };
}

export class BasicTransition {
    static fadeIn(el, speed_ms){
        el.style.transition = `opacity ${speed_ms}ms`;
        el.style.opacity = '1';
    }
    static fadeOut(el, speed_ms){
        el.style.transition = `opacity ${speed_ms}ms`;
        el.style.opacity = '0';
    }
}

export class EventActions {
    static setCoverAdjust(cover_class, header_class) {
        let header_height = header_class ? $(header_class).height() : 0;
        $(cover_class).height($(window).height() - header_height);

        window.addEventListener('resize', () => {
            $(cover_class).height($(window).height() - header_height);
        });
    }

    static setScrollButtonFade(btn_class) {
        let btn_elm = document.querySelector(btn_class);
        if(btn_elm !== null){
            btn_elm.style.opacity = '0';
            document.addEventListener('scroll', () => {
                if (window.pageYOffset > document.documentElement.clientHeight / 2) {
                    BasicTransition.fadeIn(btn_elm, 1000);
                } else {
                    BasicTransition.fadeOut(btn_elm, 1000);
                }
            });
        }
    }

    static setMediaQueryAction(media_query) {
        let mql = window.matchMedia(media_query);
        mql.addListener((e) => {
            location.reload(false);
        });
    }

    static setSmoothScroll(speed_ms){
        let links = document.querySelectorAll('a[href*="#"]');
        for(let i = 0; i < links.length; i++){
            links[i].addEventListener('click', (e) => {
                let href = e.currentTarget.getAttribute('href');
                let target = document.getElementById(href.replace('#', ''));
                let position = $(target).offset().top
                $("html, body").animate({scrollTop:position}, speed_ms, "swing");
                return false;
            });
        }
    }
}
